import Api from "./baseApi";

const controllerPath = "/address";

const CepApi = {
  get(cep, options) {
    return Api.get(`${controllerPath}/cep/${cep}`, options);
  },
};

export default CepApi;
